import Config from "../config";

export const setProviderCallbackUrl = (
  isForAlf: boolean,
  urlCallback: string
) => {
  if (isForAlf) {
    localStorage.setItem(
      "providerCallbackUrl",
      `${Config.FE_BASE_URL}/callback`
    );

    return;
  }

  localStorage.setItem("providerCallbackUrl", urlCallback || "");
};
